/**
 * Returns whether the production API URL should be absolute (pointing to the
 * API gateway) rather than a relative "/api" path (which relies on a reverse
 * proxy on the current host).
 *
 * Impersonation subdomains (*.admin.clipboard.health) serve only static SPA
 * files — they have no reverse proxy, so a relative "/api" would hit
 * CloudFront's SPA fallback and return index.html instead of JSON.
 */
export function shouldUseAbsoluteProductionApiUrl(
  locationHost: string,
  isMobile: boolean
): boolean {
  const IMPERSONATION_SUBDOMAIN_SUFFIX = ".admin.clipboard.health";

  return (
    locationHost === "clipboard.health" ||
    locationHost.endsWith(IMPERSONATION_SUBDOMAIN_SUFFIX) ||
    isMobile
  );
}
